import { useEffect } from 'react';

import { captureEnrolmentStatusFromLocation } from '@/shared/auth/passkeyEnrolment';
import { env } from '@/shared/config/env';

import { AppProviders } from './providers/AppProviders';
import { AppRoutes } from './router/routes';

/** Application root: composes providers and renders the active route. */
export default function App() {
  useEffect(() => {
    document.title = env.appName;
  }, []);

  // Once per boot, and before anything else can act on the boot URL: `BffSessionProvider`'s own
  // return-path restore (inside `AppProviders` → `SessionProvider`, a descendant of this component)
  // only fires once its `/me` fetch resolves — strictly later than this effect, which runs on this
  // component's own mount. Capturing here, first, is what keeps Keycloak's `kc_action_status` from
  // being silently dropped when `BffSessionProvider` navigates the query string away (design doc §11
  // step 2; user-story-merchant-portal-060).
  useEffect(() => {
    captureEnrolmentStatusFromLocation();
  }, []);

  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  );
}
